import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Trash2, Plus, ArrowUp, ArrowDown } from "lucide-react";

export function Field({ label, value, onChange, multiline, testid, placeholder, type = "text" }) {
  const C = multiline ? Textarea : Input;
  return (
    <div className="space-y-1.5">
      <Label className="text-xs text-slate-600">{label}</Label>
      <C data-testid={testid} type={type} value={value ?? ""} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} className={multiline ? "min-h-[72px]" : ""} />
    </div>
  );
}

export function Panel({ title, description, children, onSave, saving, saveTestid }) {
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6">
      <div className="flex items-start justify-between gap-4 mb-5">
        <div>
          <h2 className="font-display font-bold text-lg text-slate-900">{title}</h2>
          {description && <p className="text-xs text-slate-500 mt-1">{description}</p>}
        </div>
        {onSave && (
          <Button data-testid={saveTestid} onClick={() => onSave()} disabled={saving} className="rounded-xl bg-emerald-700 hover:bg-emerald-800 text-white shrink-0">
            {saving ? "Saving…" : "Save & Publish"}
          </Button>
        )}
      </div>
      {children}
    </div>
  );
}

export function ListControls({ index, total, onMove, onRemove, testid }) {
  return (
    <div className="flex items-center gap-1">
      <Button size="icon" variant="ghost" className="h-8 w-8" disabled={index === 0} onClick={() => onMove(index, index - 1)} aria-label="Move up"><ArrowUp className="w-4 h-4" /></Button>
      <Button size="icon" variant="ghost" className="h-8 w-8" disabled={index === total - 1} onClick={() => onMove(index, index + 1)} aria-label="Move down"><ArrowDown className="w-4 h-4" /></Button>
      <Button size="icon" variant="ghost" data-testid={testid} className="h-8 w-8 text-red-600 hover:text-red-700" onClick={() => onRemove(index)} aria-label="Delete"><Trash2 className="w-4 h-4" /></Button>
    </div>
  );
}

export function AddButton({ onClick, label, testid }) {
  return (
    <Button variant="outline" data-testid={testid} onClick={onClick} className="rounded-xl border-dashed border-slate-300 w-full mt-4">
      <Plus className="w-4 h-4 mr-2" /> {label}
    </Button>
  );
}

export function moveItem(list, from, to) {
  const next = [...list];
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item);
  return next;
}
